
import axios from '../config/axios';

export const url = '/api/pdfdeestudioszlzwd'


export const getOnepdfdeestudioszlzwd = ({
  token,
  _id,
}) => new Promise((resolve, reject) => {
  if (token && _id) {
    axios.get(`${url}//one/basic/69745f1ba85c3d434df35b05/${_id}`, {
      headers: {
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch((error) => reject(error));
  } else if (!_id) {
    reject({
      status: 'error',
      info: 'Identificador no definido'
    });
  } else {
    reject({
      status: 'error',
      info: 'Token no definido',
    });
  }
});
      
export const customobtenerunarchivogwx58_697684c0a85c3d434df35ef6 = ({
  publicacioneohp,

}) => new Promise((resolve, reject) => {
  if (true) {
    axios.get(`${url}/custom/archivo`, {
      params: {
        publicacioneohp,

      },
      
    }).then((res) => {
      if (res.data.status === 'success') {
        resolve(res.data);
      } else {
        reject(res.data); 
      }
    }).catch((error) => {
      reject(error?.response?.data);
    });
  } else {
    reject({
      status: 'error',
      info: 'Verifique los parametros requeridos',
    });
  }
});



